import { render, staticRenderFns } from "./warranty_preferences.vue?vue&type=template&id=2e98eb21&"
import script from "./warranty_preferences.vue?vue&type=script&lang=js&"
export * from "./warranty_preferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports